export default __webpack_public_path__ + "static/media/arrowDown.4b0082c5.svg";